import { render, staticRenderFns } from "./project-proportion.vue?vue&type=template&id=3834b8bc&scoped=true&"
import script from "./project-proportion.vue?vue&type=script&lang=js&"
export * from "./project-proportion.vue?vue&type=script&lang=js&"
import style0 from "./project-proportion.vue?vue&type=style&index=0&id=3834b8bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3834b8bc",
  null
  
)

export default component.exports